import { combineReducers } from "@reduxjs/toolkit";
import employeeReducer from "./scenes/employee/employeeSlice";
import payrollReducer from "./scenes/payroll/payroll.slice";

const rootReducer = combineReducers({
  employee: employeeReducer,
  payroll: payrollReducer,
});

export default rootReducer;
